"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Hero = _ref => {
  let {
    heroStyle,
    title,
    desc,
    primaryBtnHref,
    primaryBtnText,
    secondaryBtnHref,
    secondaryBtnText
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: `${heroStyle} bg-[#091f2c4d] `,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "App-hero min-h-[781px]",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
        className: "container ",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "App-hero_content mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-16",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "items-center justify-center mt-[137px] ",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "lg:py-20 text-center ",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
                className: "max-w-[784px]",
                children: [" ", title]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                className: "mt-4 emphasis_para max-w-[814px]",
                children: desc
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "mt-7 block sm:flex justify-center gap-5",
                children: [primaryBtnText && /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                  href: primaryBtnHref,
                  className: "primary-btn inline-flex items-center port:!w-[100%]",
                  children: primaryBtnText
                }), secondaryBtnText && /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                  href: secondaryBtnHref,
                  className: "secondary-btn inline-flex items-center port:!w-[100%] port:mt-4",
                  children: secondaryBtnText
                })]
              })]
            })
          })
        })
      })
    })
  });
};
var _default = Hero;
exports.default = _default;